<template>
  <b-section-loader :loading="$loading.isLoading('getDelegation')">
    <div class="d-flex flex-column ga-3 mt-3">
      <div class="d-flex align-center ga-3">
        <v-avatar color="blue-darken-3" size="48">
          <span class="text-white font-weight-bold font-size-16">
            {{ initials }}
          </span>
        </v-avatar>
        <div class="d-flex flex-column">
          <span class="font-weight-bold font-size-18">{{
            getPersonName(delegation.user)
          }}</span>
          <div class="d-flex text-disabled align-center font-size-13 ga-1">
            <span v-if="delegation.startDate">
              {{ new CustomDate(delegation.startDate).toString() }}
              —
              {{
                delegation.endDate
                  ? new CustomDate(delegation.endDate).toString()
                  : '∞'
              }}
            </span>
            <span>·</span>
            <span>Документів: {{ totalDocuments }}</span>
          </div>
        </div>
      </div>

      <span class="font-weight-bold font-size-15"> Доступ до підрозділів </span>
      <div class="d-flex flex-column ga-3">
        <v-card
          v-for="item in accessBlocks"
          :key="item.id"
          :class="`access-card--${item.color}`"
          class="access-card"
          @click="goTo(item)">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center ga-3">
                <div :class="`icon--${item.color}`" class="icon">
                  {{ item.icon }}
                </div>

                <div class="d-flex flex-column">
                  <span class="font-weight-bold font-size-15">
                    {{ item.title }}
                  </span>
                  <span class="text-disabled">
                    {{ item.count }} документ(ів)
                  </span>
                </div>
              </div>

              <div class="d-flex align-center ga-3">
                <v-chip :color="getChipColor(item.color)" variant="flat">
                  <span class="font-weight-bold text-white">
                    {{ item.count }}
                  </span>
                </v-chip>

                <v-icon color="grey">mdi-chevron-right</v-icon>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </b-section-loader>
</template>

<script lang="ts">
import { computed } from 'vue'
import { useDelegation } from './index'
import { BSectionLoader } from 'best-modules/components'
import { useRoute, useRouter } from 'vue-router'
import { CustomDate, getPersonName } from 'best-modules/utils'

type ColorType = 'blue' | 'amber' | 'green'
interface AccessBlock {
  id: number
  title: string
  count: number
  icon: string
  color: ColorType
  route: { name: string }
}
export default {
  name: 'DelegationSingle',
  components: { BSectionLoader },
  methods: { CustomDate, getPersonName },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { delegation, summary } = useDelegation()

    const initials = computed(() => {
      const u = delegation.user
      if (!u) return ''
      return `${u.surname?.[0] ?? ''}${u.name?.[0] ?? ''}`
    })

    const accessBlocks = computed<AccessBlock[]>(() => [
      {
        id: 1,
        title: 'Погодження',
        count: summary.agreements,
        icon: '✓',
        color: 'blue',
        route: { name: 'delegation-agreements' },
      },
      {
        id: 2,
        title: 'Підписання',
        count: summary.signatures,
        icon: '✍',
        color: 'amber',
        route: { name: 'delegation-signatures' },
      },
    ])

    const totalDocuments = computed(
      () => summary.agreements + summary.signatures
    )

    const getChipColor = (color: ColorType) => {
      switch (color) {
        case 'blue':
          return 'light-blue-darken-3'
        case 'amber':
          return 'amber-darken-3'
        case 'green':
          return 'green-darken-3'
      }
    }

    const goTo = (item: any) => {
      router.push({
        name: item.route.name,
        params: { id: route.params.id },
      })
    }

    return {
      delegation,
      summary,
      initials,
      accessBlocks,
      totalDocuments,
      getChipColor,
      goTo,
    }
  },
}
</script>

<style lang="scss" scoped>
.access-card {
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
  cursor: pointer;
  background: white;
  box-sizing: border-box;

  &:hover {
    .icon--blue {
      background: transparent;
    }
    .icon--amber {
      background: transparent;
    }
    .icon--green {
      background: transparent;
    }
  }
}

.icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  background: transparent;
  transition: all 0.2s ease;
}

.icon--blue {
  background: rgba(25, 118, 210, 0.12);
}

.icon--amber {
  background: rgba(255, 143, 0, 0.12);
}

.icon--green {
  background: rgba(46, 125, 50, 0.12);
}

.access-card--blue {
  &:hover {
    border: 1px solid #1976d2 !important;
    background: rgba(33, 150, 243, 0.08);
  }
}

.access-card--amber {
  &:hover {
    border: 1px solid #c07a00 !important;
    background: rgba(255, 245, 230);
  }
}

.access-card--green {
  &:hover {
    border: 1px solid #2e7d32 !important;
    background: rgba(76, 175, 80, 0.08);
  }
}
</style>
